import React, {type ComponentProps} from 'react';
import {Link} from 'react-router-dom';

import * as GlobalActions from 'actions/global_actions';
import {isMobile} from 'utils/user_agent';
import {Constants} from 'utils/constants';
import OverlayTrigger from 'components/overlay_trigger';
import Tooltip from 'components/tooltip';

import Timestamp, {RelativeRanges} from 'components/timestamp';
import PostContext from '../post_context';

const POST_TOOLTIP_RANGES = [
    RelativeRanges.TODAY_TITLE_CASE,
    RelativeRanges.YESTERDAY_TITLE_CASE,
];

type Props = {

    /*
     * If true, time will be rendered as a permalink to the post
     */
    isPermalink: boolean;

    /*
     * The time to display
     */
    eventTime: number;

    isMobileView: boolean;

    /*
     * The post id of posting being rendered
     */
    postId: string;
    teamUrl: string;
    timestampProps?: ComponentProps<typeof Timestamp>;
}

export default class PostTime extends React.PureComponent<Props> {
    static contextType = PostContext;
    declare context: React.ContextType<typeof PostContext>

    static defaultProps: Partial<Props> = {
        eventTime: 0,
    };

    handleClick = () => {
        if (this.props.isMobileView) {
            GlobalActions.emitCloseRightHandSide();
        }
    };

    render() {
        const {
            eventTime,
            isPermalink,
            postId,
            teamUrl,
            timestampProps = {},
        } = this.props;

        const postTime = (
            <Timestamp
                value={eventTime}
                className='post__time'
                useDate={false}
                {...timestampProps}
            />
        );

        const content = isMobile() || !isPermalink ? (
            <div
                role='presentation'
                className='post__permalink post_permalink_mobile_view'
            >
                {postTime}
            </div>
        ) : (
            <Link
                id={`${this.context.location}_time_${postId}`}
                to={`${teamUrl}/pl/${postId}`}
                className='post__permalink'
                onClick={this.handleClick}
            >
                {postTime}
            </Link>
        );

        return (
            <OverlayTrigger
                delayShow={Constants.OVERLAY_TIME_DELAY}
                placement='top'
                className='hidden-xs'
                overlay={
                    <Tooltip
                        id={eventTime.toString()}
                        className='hidden-xs'
                    >
                        <Timestamp
                            value={eventTime}
                            ranges={POST_TOOLTIP_RANGES}
                        />
                    </Tooltip>
                }
            >
                {content}
            </OverlayTrigger>
        );
    }
}
